import { format as formatDateFns } from 'date-fns';
import { TZDate } from '@date-fns/tz';
export const formatDate = (date, format = 'MMM dd, yyyy', { timeZone } = {}) => {
    if (!date) {
        return null;
    }
    if (format === 'auto') {
        return autoDateFormat(date);
    }
    let dateObj = new Date(date);
    if (timeZone) {
        dateObj = new TZDate(dateObj, timeZone);
    }
    return formatDateFns(dateObj, format);
};
export function autoDateFormat(datetime) {
    const date = new Date(datetime);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diff / (1000 * 60));
    const diffHours = Math.floor(diff / (1000 * 60 * 60));
    const diffMinutesAbs = Math.abs(diffMinutes);
    const diffHoursAbs = Math.abs(diffHours);
    const prefix = diffMinutes < 0 ? 'in ' : '';
    const suffix = diffMinutes > 0 ? ' ago' : '';
    if (diffMinutesAbs < 1) {
        return 'now';
    }
    else if (diffMinutesAbs < 60) {
        return `${prefix}${diffMinutesAbs} minute${diffMinutesAbs === 1 ? '' : 's'}${suffix}`;
    }
    else if (diffHoursAbs < 3) {
        return `${prefix}${diffHoursAbs} hour${diffHoursAbs === 1 ? '' : 's'}${suffix}`;
    }
    else if (date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear()) {
        return `Today, ${formatDateFns(new Date(date), 'HH:mm')}`;
    }
    else {
        return formatDateFns(new Date(date), 'MM/dd/yyyy h:mm:ss');
    }
}
